var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSortbyicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7095",
    "data-name": "Rectangle 7095",
    width: 18,
    height: 18,
    transform: "translate(308.365 314.366)",
    fill: "#fff",
    stroke: "#3b86ff",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_7012",
    "data-name": "Mask Group 7012",
    transform: "translate(-308.365 -314.366)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21842",
    "data-name": "Group 21842",
    transform: "translate(311.614 316.829)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21840",
    "data-name": "Group 21840",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_988",
    "data-name": "Line 988",
    y2: 12.999,
    transform: "translate(2.483)",
    fill: "none",
    stroke: "#3b86ff",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45686",
    "data-name": "Path 45686",
    d: "M-6801.125-11308.816l2.483,2.484,2.482-2.484",
    transform: "translate(6801.125 11319.407)",
    fill: "none",
    stroke: "#3b86ff",
    strokeLinecap: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21841",
    "data-name": "Group 21841",
    transform: "translate(6.537 0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_988-2",
    "data-name": "Line 988",
    y1: 12.999,
    transform: "translate(2.483 0.075)",
    fill: "none",
    stroke: "#3b86ff",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45686-2",
    "data-name": "Path 45686",
    d: "M-6801.125-11306.332l2.483-2.484,2.482,2.484",
    transform: "translate(6801.125 11308.816)",
    fill: "none",
    stroke: "#3b86ff",
    strokeLinecap: "round",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortbyicon);
export default __webpack_public_path__ + "static/media/sortbyicon.29ba7fd70ad7f6ee126f1f09f21aa4c8.svg";
export { ForwardRef as ReactComponent };